<template>
  <div class="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style>
.app {
  position: relative;
  height: 100%;
}
body {
  background-color: #f0f2f5;
  font-size: 16px !important;
}
button {
  cursor: pointer;
}
</style>
<style>
 .el-table th.el-table__cell {
  background-color: #f1f1f1;
}
.el-tooltip__popper {
  max-width: 20%;
}

.el-tooltip__popper.is-dark {
  background: #f5f5f5 !important;
  color: #303133 !important;
}

@import url("@/common/common.css");
</style>